<template>
<div>
    <b-form @submit="onSubmit" class="text-center pt-4">
      <!--<div v-if="selectedUnit" class="mt-2">
        <AlertSelectedUnit :selectedUnit="selectedUnit"/>
      </div>-->
    <b-row class="pt-4">
      <b-col>
        <h3>{{$t('label.register')}}</h3>
      </b-col>
    </b-row>
    <!-- fname -->
    <b-row align-h="center">        
      <b-col sm="6" class="mt-4">
        <b-form-input v-model.trim="$v.form.fname.$model" :placeholder="$t('label.fname')"></b-form-input>
        <div class="text-danger" v-if="!$v.form.fname.required && $v.form.fname.$dirty">{{ $t("info.required") }}</div>
        <div class="text-danger" v-if="!$v.form.fname.maxLength && $v.form.fname.$dirty">{{ $t("info.maxLength", [75]) }}</div>
      </b-col>
    </b-row>
    <!-- lname -->
    <b-row align-h="center">
        <b-col sm="6" class="mt-4">
        <b-form-input v-model.trim="$v.form.lname.$model" :placeholder="$t('label.lname')"></b-form-input>
        <div class="text-danger" v-if="!$v.form.lname.required && $v.form.lname.$dirty">{{ $t("info.required") }}</div>
        <div class="text-danger" v-if="!$v.form.lname.maxLength && $v.form.lname.$dirty">{{ $t("info.maxLength", [75]) }}</div>
        </b-col>
    </b-row>
    <!-- email -->
    <b-row align-h="center">
        <b-col sm="6" class="mt-4">
        <b-form-input v-model.trim="$v.form.email.$model" :placeholder="$t('label.email')"></b-form-input>
        <div class="text-danger" v-if="!$v.form.email.required && $v.form.email.$dirty">{{ $t("info.required") }}</div>
        <div class="text-danger" v-if="!$v.form.email.email && $v.form.email.$dirty">{{ $t("info.email") }}</div>
        <div class="text-danger" v-if="!$v.form.email.maxLength && $v.form.email.$dirty">{{ $t("info.maxLength", [75]) }}</div>
        </b-col>
    </b-row>
    <!-- paswd -->
    <b-row align-h="center">
        <b-col sm="6" class="mt-4">
        <b-input-group>
          <b-form-input :type="paswdVisibility ? 'text' : 'password'" v-model.trim="$v.form.paswd.$model" :placeholder="$t('label.paswd')"></b-form-input>
          <template #append>
            <b-input-group-text><span @click="paswdVisibility = !paswdVisibility"><font-awesome-icon :icon="iconPaswd" /></span></b-input-group-text>
          </template>
        </b-input-group>
        
        <div class="text-danger" v-if="!$v.form.paswd.required && $v.form.paswd.$dirty">{{ $t("info.required") }}</div>
        <div class="text-danger" v-if="!$v.form.paswd.maxLength && $v.form.paswd.$dirty">{{ $t("info.maxLength", [20]) }}</div>
        <div class="text-danger" v-if="!$v.form.paswd.minLength && $v.form.paswd.$dirty">{{ $t("info.minLength", [8]) }}</div>
        <div class="text-danger" v-if="paswdInvalid">{{ $t("info.paswdValidation") }}</div>
        <b-form-text id="password-int">{{$t('info.paswdInt')}}</b-form-text>
        </b-col>
    </b-row>

    <b-row align-h="center">
        <b-col sm="6" class="mt-4">
        <b-input-group>
          <b-form-input :type="confPaswdVisibility ? 'text' : 'password'" v-model.trim="$v.form.confPaswd.$model" :placeholder="$t('label.confPaswd')"></b-form-input>
          <template #append>
            <b-input-group-text><span @click="confPaswdVisibility = !confPaswdVisibility"><font-awesome-icon :icon="iconConfPaswd" /></span></b-input-group-text>
          </template>
        </b-input-group>      
        <div class="text-danger" v-if="!$v.form.confPaswd.sameAsPassword && $v.form.confPaswd.$dirty">{{ $t("info.sameAs") }}</div>
        </b-col>
    </b-row>

    <b-row align-h="center">
        <b-col sm="6" class="mt-4">
          <b-form-select v-model.trim="$v.form.communication.$model" :options="communications"></b-form-select>
          <div class="text-danger" v-if="!$v.form.communication.required && $v.form.communication.$dirty">{{ $t("info.required") }}</div>
        </b-col>     
      </b-row>

     <!-- <b-row align-h="center">
      <b-col sm=6 class="mt-4">
          <b-form-checkbox
            id="optIn"
            v-model="form.optIn"
            name="optIn"
            value="selected"
            unchecked-value=""
          >
            {{$t('info.optIn')}}
          </b-form-checkbox>
      </b-col>
    </b-row> -->
    
    <b-button class="mt-4" type="submit" variant="success" :disabled="disabled">{{ $t("label.submit") }}</b-button>

    </b-form>

    <!-- spinner -->
    <div v-if="spinner" class="text-center pt-2">
      <b-spinner style="width: 3rem; height: 3rem;" variant="success" label="Spinning" disabled="labelStatus"></b-spinner>
    </div>

    <!-- Account Created -->
    <div v-if="success" class="text-center pt-4">
        <b-alert show variant="warning">
            <p>{{ $t("info.accountSuccess") }}</p>
        </b-alert>
    </div>

    <!-- temp user -->
    <div v-if="tempUser" class="text-center pt-4">
        <b-alert show variant="warning">
            <p>{{ $t("info.tempUser") }}</p>
        </b-alert>
    </div>

    <!-- User exist -->
    <div v-if="userExist" class="text-center pt-4">
        <b-alert show variant="warning">
            <p>{{ $t("info.userExist") }}</p>
        </b-alert>
    </div>

    <!-- error -->
    <div v-if="error" class="text-center pt-4">
        <b-alert show variant="danger">
            <p>{{ error }}</p>
        </b-alert>
    </div>
    
</div>
</template>

<script>

import axios from 'axios';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import { required, email, maxLength, minLength, sameAs } from 'vuelidate/lib/validators';
import { globalF } from './Helpers';

export default {  
mixins: [globalF],  
props: [],
data() {
    return {
      form: {
        fname: "",
        lname: "",
        email: "",
        paswd: "",
        communication: null,
        optIn: "",
        confPaswd: "",
      },     
      error: "",
      success: false,
      disabled: false,
      spinner: false,
      paswdInvalid: false,
      paswdVisibility: false,
      confPaswdVisibility: false,
      userExist: false,
      tempUser: false
    }
  },
validations() {
    return {
      form: {
        fname: {
          required,
          maxLength: maxLength(75)
        },
        lname: {
          required,
          maxLength: maxLength(75)
        },
        email: {
          required,
          email,
          maxLength: maxLength(75)
        },
        paswd: {
          required,
          maxLength: maxLength(20),
          minLength: minLength(8)
        },
        communication : {
          required
        },
        confPaswd: {
          sameAsPassword: sameAs('paswd')
        }
    }
  }
},
computed: {
  iconPaswd: function () {
    return this.paswdVisibility ? faEye : faEyeSlash;
  },
  iconConfPaswd: function () {
    return this.confPaswdVisibility ? faEye : faEyeSlash;
  },
  url: function () {
    let urls = this.$store.getters.getUrlsList;
    return urls[process.env.VUE_APP_WHERE].json;
  },
  communications: function () {
    return [
        {value: null, text: this.$t('label.communication')},
        {value: 1, text: this.$t('label.french')},
        {value: 2, text: this.$t('label.english')}
      ];
  },
  /*selectedUnit: function () {
      let buldingsList = this.$store.getters.getBuildings;
      let selected = this.getQueryStringValue();
      let buildFormat = null;
      if (selected.length > 0) {
        let build = buldingsList.find(b => b.NOCIE === selected[0].NOCIE && b.NODIV === selected[0].NODIV && b.Immeuble.trim() === selected[0].IMMEUBLE.trim());
        buildFormat.name = build.NOMDIV+ " ("+  build.Street + ", " + build.City + ", " + build.Province+" )";
        buildFormat.unit = " # " +selected[0].UNITE;
        buildFormat.specs = {NBPIECE: selected[0].NBPIECE, publicUnitPrice: selected[0].publicUnitPrice };//moment(selected[0].DATEDEP).add(1, 'd').format("YYYY-MM-DD")};
      }
      return buildFormat;
    },*/
},
methods:{
    validatePaswd : function () {
        let paswd = this.form.paswd;
        let pass = false;
        let letter = false;
        let digit = false;
        let uppercase = false;
        let acceptedChar = false;
        let lettersNumbersReg = /^[0-9a-zA-Z]+$/;
        let lettersReg = /^[a-zA-Z]+$/;

        for (let i=0; i < paswd.length; i++) {
            let char = paswd.charAt(i);

            //acceptedChar
            if (lettersNumbersReg.test(char)) {
                acceptedChar = true;
                //letter
                if (lettersReg.test(char)) {
                    letter = true;
                    //uppercase
                    if (char == char.toUpperCase()) {
                        uppercase = true;
                    }
                }
                
                //digit
                if (!isNaN(char)){
                    digit = true;
                }

            }

            else {
                acceptedChar = false;
                break;
            }
        }

        if (acceptedChar && letter && uppercase && digit) {
            pass = true;
        }

        else {
            this.paswdInvalid = true;
        }

        return pass;
    },
    async recaptcha() {
      // (optional) Wait until recaptcha has been loaded.
      await this.$recaptchaLoaded();

      // Execute reCAPTCHA with action "login".
      const token = await this.$recaptcha('register');

      return token;
    },
    onSubmit(evt) {
      evt.preventDefault();
      this.error = "";
      this.paswdInvalid = false;
      this.success = false;
      this.userExist = false;
      this.tempUser = false;
      this.$v.$touch();
      if (!this.$v.$invalid && this.validatePaswd()) { 

        this.disabled = true;
        this.spinner = true;

        let promise = this.recaptcha();
          promise.then((token) => {

            let obj = {
              response: token
            }

            axios.post(this.url, {request: "getCaptchaResponse", form: obj }, { headers: {'Content-Type': 'application/json'}})
              .then((response)  => {
                let resp = JSON.parse(response.data);
                if (resp.success && resp.action === 'register' && resp.score > 0.5) {                 
                  this.registerUser();
                }
                else {
                  this.disabled = false;
                  this.spinner = false;
                  this.error = this.$t('info.errorCaptcha');
                }
              })
              .catch(()  => {
                  this.disabled = false;
                  this.spinner = false;
                  this.error = this.$t('info.errorgeneric');
              });

          });
          
      }
    },
    registerUser() {

      this.form.optIn = this.form.optIn === "" ? 2 : 1;
          
          //this.disabled = true;
          //this.spinner = true;
          
          axios.post(this.url, {request: "registerNewUser", form: this.form }, { headers: {'Content-Type': 'application/json'}})
            .then((response)  => {
                this.spinner = false;

                if (response.data === 202) {
                  this.success = true;
                }
                else if(response.data === 1) {
                  this.userExist = true;
                  this.disabled = false;
                }
                else if(response.data === 2) {
                  this.tempUser = true;
                  this.disabled = false;
                }
                else {
                  this.error = this.$t('info.errorgeneric');
                  this.disabled = false;
                }
                
            })
            .catch(()  => {
                this.error = this.$t('info.errorgeneric');
                this.spinner = false;
                this.disabled = false;
            }); 

    },
    setNextPage(page) {      
      this.$emit('changePage', page);        
    }
},
components: {}
}
</script>